exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kv-result-table[_v-19130785]{margin-bottom:20px}.kv-result-table td[_v-19130785]{padding:4px;border:1px solid #c3c3c3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-19130785&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/templates/UniversalKV.vue
// module id = 146
// module chunks = 0